<template>
    <!-- BEGIN: Footer-->
    <footer class="footer footer-static footer-light">
      <p class="clearfix mb-0">
        <span class="float-md-start d-block d-md-inline-block mt-25">
          COPYRIGHT © {{ new Date().getFullYear() }}
          <a
              href="https://musketeersidea.com/"
              target="_blank"
              class="ms-25"
          >
            Musketeers Idea Ltd. (miSoftware)
          </a>
        </span>
      </p>
     </footer>
    <button 
        @click="goToTop" 
        class="btn btn-primary btn-icon scroll-top" 
        type="button"
    >
        <img height="15" src="/app-assets/images/icons/arrow-up.svg" alt="">
    </button>
    <!-- END: Footer-->
</template>

<script>
export default {
    name: 'Footer',
    methods: {
        goToTop () {
            window.scroll({
                top: 5,
                left: 5,
                behavior: 'smooth'
            });
        }
    }
}
</script>
